import {post, get, del} from '@/utils/request'

// 查询日期分类数量
export function orderDateGroupNums(data) {
    return post({
        data,
        url: 'tbs/TbsTelecomOrder/orderDateGroupNums'
    })
}

// 查询当前月每天的订单数量
export function orderCurrentMonthEveryDayNums(data) {
    return post({
        url: `tbs/TbsTelecomOrder/orderCurrentMonthEveryDayNums`
    })
}

// 查询订单分类数量
export function orderTypeGroupNums(data) {
    return post({
        data,
        url: 'tbs/TbsTelecomOrder/orderTypeGroupNums'
    })
}
// 订单列表
export function orderlist(data) {
    return post({
        data,
        url: 'tbs/TbsTelecomOrder/orderlist'
    })
}
// 订单详情
export function orderDetail(data) {
    return post({
        data,
        url: 'tbs/TbsTelecomOrder/orderDetail'
    })
}

// 录入登记
export function logRegister(data) {
    return post({
        data,
        url: 'tbs/TbsTelecomOrder/updatePhoneNumber'
    })
}

// 订单详情提交
export function orderForm(data) {
    return post({
        data,
        url: 'tbs/reward/check'
    })
}